import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

function handleForm(event) { event.preventDefault(); } 
document.addEventListener('submit', handleForm);

console.log(process.env.REACT_APP_ROOT_URL);

if(!process.env.REACT_APP_ROOT_URL) {
  console.error("No URL FOUND");
  process.kill(1);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
